import "../../../../../../../../../chunks/async.js";
import { j as await_block, b as escape_html, e as ensure_array_like, g as attr_style, a as attr, s as stringify } from "../../../../../../../../../chunks/renderer.js";
import { P as Panel } from "../../../../../../../../../chunks/Panel.js";
import { a as formatNumber, f as formatBytes } from "../../../../../../../../../chunks/filters.js";
import { f as formatShardKey } from "../../../../../../../../../chunks/shardKey.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const { data } = $$props;
    function pct(value, total) {
      if (total <= 0) {
        return 0;
      }
      return Math.round(value / total * 100);
    }
    const shardColors = [
      "hsl(210, 70%, 55%)",
      "hsl(150, 60%, 45%)",
      "hsl(38, 92%, 50%)",
      "hsl(280, 60%, 58%)",
      "hsl(0, 70%, 58%)",
      "hsl(190, 65%, 48%)",
      "hsl(330, 65%, 58%)",
      "hsl(95, 55%, 45%)"
    ];
    await_block(
      $$renderer2,
      data.sharding,
      () => {
        Panel($$renderer2, {
          title: "Sharding",
          children: ($$renderer3) => {
            $$renderer3.push(`<div class="loading p-4">Loading sharding info...</div>`);
          },
          $$slots: { default: true }
        });
      },
      (result) => {
        if (!result || result.error) {
          $$renderer2.push("<!--[0-->");
          Panel($$renderer2, {
            title: "Sharding",
            children: ($$renderer3) => {
              $$renderer3.push(`<div class="p-4"><p class="error svelte-1y8drq2">${escape_html(result?.error ?? "Failed to load sharding info")}</p></div>`);
            },
            $$slots: { default: true }
          });
        } else {
          $$renderer2.push("<!--[-1-->");
          const info = result.data;
          if (!info) {
            $$renderer2.push("<!--[0-->");
            Panel($$renderer2, {
              title: "Sharding",
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="p-4 text-center" style="color: var(--text-darker);">No data</div>`);
              },
              $$slots: { default: true }
            });
          } else if (!info.shardingEnabled) {
            $$renderer2.push("<!--[1-->");
            Panel($$renderer2, {
              title: "Sharding",
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="p-6 text-center"><div class="text-3xl mb-2">⛁</div> <p style="color: var(--text);">This server is not a sharded cluster.</p> <p class="text-sm mt-1" style="color: var(--text-darker);">Connect through a <code>mongos</code> router to view shard distribution.</p></div>`);
              },
              $$slots: { default: true }
            });
          } else {
            $$renderer2.push("<!--[-1-->");
            const totalChunks = info.totalChunks;
            const totalDocs = info.shards.reduce((acc, s) => acc + (s.documents ?? 0), 0);
            const totalSize = info.shards.reduce((acc, s) => acc + (s.size ?? 0), 0);
            Panel($$renderer2, {
              title: "Sharding status",
              class: "mb-4",
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="p-4 flex flex-wrap gap-4 items-center">`);
                if (info.sharded) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<span class="badge badge-sharded svelte-1y8drq2">Sharded</span>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                  $$renderer3.push(`<span class="badge badge-unsharded svelte-1y8drq2">Not sharded</span>`);
                }
                $$renderer3.push(`<!--]--> `);
                if (info.hashed) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<span class="badge badge-prop svelte-1y8drq2">hashed</span>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (info.unique) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<span class="badge badge-prop svelte-1y8drq2">unique key</span>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (info.sharded) {
                  $$renderer3.push("<!--[0-->");
                  if (info.balancerEnabled) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<span class="badge badge-ok svelte-1y8drq2">balancer on</span>`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<span class="badge badge-warn svelte-1y8drq2">balancing disabled</span>`);
                  }
                  $$renderer3.push(`<!--]-->`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (info.shardKey) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<div class="key-pill svelte-1y8drq2" title="Shard key"><span class="key-label svelte-1y8drq2">shard key</span> <span class="font-mono text-sm">${escape_html(formatShardKey(info.shardKey))}</span></div>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--> `);
                if (info.sharded) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<div class="ml-auto text-sm" style="color: var(--text-darker);">${escape_html(formatNumber(totalChunks))} chunk${escape_html(totalChunks === 1 ? "" : "s")} across ${escape_html(info.shards.length)} shard${escape_html(info.shards.length === 1 ? "" : "s")}</div>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--></div> `);
                if (info.warning) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<div class="px-4 pb-3 text-sm" style="color: var(--warning, hsl(38, 92%, 45%));">⚠ ${escape_html(info.warning)}</div>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]-->`);
              },
              $$slots: { default: true }
            });
            $$renderer2.push(`<!----> `);
            if (info.sharded && totalChunks > 0) {
              $$renderer2.push("<!--[0-->");
              Panel($$renderer2, {
                title: "Chunk distribution",
                class: "mb-4",
                children: ($$renderer3) => {
                  $$renderer3.push(`<div class="p-4"><div class="dist-bar svelte-1y8drq2"><!--[-->`);
                  const each_array = ensure_array_like(info.shards);
                  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
                    let shard = each_array[i];
                    if (shard.chunks > 0) {
                      $$renderer3.push("<!--[0-->");
                      $$renderer3.push(`<div class="dist-seg svelte-1y8drq2"${attr_style(`width: ${stringify(pct(shard.chunks, totalChunks))}%; background: ${stringify(shardColors[i % shardColors.length])};`)}${attr("title", `${stringify(shard.shardId)}: ${stringify(shard.chunks)} chunks (${stringify(pct(shard.chunks, totalChunks))}%)`)}>`);
                      if (pct(shard.chunks, totalChunks) >= 8) {
                        $$renderer3.push("<!--[0-->");
                        $$renderer3.push(`${escape_html(pct(shard.chunks, totalChunks))}%`);
                      } else {
                        $$renderer3.push("<!--[-1-->");
                      }
                      $$renderer3.push(`<!--]--></div>`);
                    } else {
                      $$renderer3.push("<!--[-1-->");
                    }
                    $$renderer3.push(`<!--]-->`);
                  }
                  $$renderer3.push(`<!--]--></div> <div class="legend svelte-1y8drq2"><!--[-->`);
                  const each_array_1 = ensure_array_like(info.shards);
                  for (let i = 0, $$length = each_array_1.length; i < $$length; i++) {
                    let shard = each_array_1[i];
                    $$renderer3.push(`<div class="legend-item svelte-1y8drq2"><span class="legend-dot svelte-1y8drq2"${attr_style(`background: ${stringify(shardColors[i % shardColors.length])};`)}></span> <span class="font-mono text-xs">${escape_html(shard.shardId)}</span></div>`);
                  }
                  $$renderer3.push(`<!--]--></div></div>`);
                },
                $$slots: { default: true }
              });
            } else {
              $$renderer2.push("<!--[-1-->");
            }
            $$renderer2.push(`<!--]--> `);
            Panel($$renderer2, {
              title: "Per-shard breakdown",
              children: ($$renderer3) => {
                $$renderer3.push(`<div class="table-wrapper svelte-1y8drq2"><table class="table"><thead><tr><th>Shard</th><th>Host</th>`);
                if (info.sharded) {
                  $$renderer3.push("<!--[0-->");
                  $$renderer3.push(`<th class="shrink-column svelte-1y8drq2">Chunks</th>`);
                } else {
                  $$renderer3.push("<!--[-1-->");
                }
                $$renderer3.push(`<!--]--><th class="shrink-column svelte-1y8drq2">Documents</th><th class="shrink-column svelte-1y8drq2">Size</th></tr></thead><tbody><!--[-->`);
                const each_array_2 = ensure_array_like(info.shards);
                for (let i = 0, $$length = each_array_2.length; i < $$length; i++) {
                  let shard = each_array_2[i];
                  $$renderer3.push(`<tr><td><span class="legend-dot inline-block mr-2 svelte-1y8drq2"${attr_style(`background: ${stringify(shardColors[i % shardColors.length])};`)}></span> <span class="font-mono text-sm">${escape_html(shard.shardId)}</span></td><td><span class="font-mono text-xs" style="color: var(--text-darker);">${escape_html(shard.host)}</span></td>`);
                  if (info.sharded) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`<td>${escape_html(formatNumber(shard.chunks))} <span class="text-xs" style="color: var(--text-darker);">(${escape_html(pct(shard.chunks, totalChunks))}%)</span></td>`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                  }
                  $$renderer3.push(`<!--]--><td>`);
                  if (shard.documents != null) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`${escape_html(formatNumber(shard.documents))} `);
                    if (totalDocs > 0) {
                      $$renderer3.push("<!--[0-->");
                      $$renderer3.push(`<span class="text-xs" style="color: var(--text-darker);">(${escape_html(pct(shard.documents, totalDocs))}%)</span>`);
                    } else {
                      $$renderer3.push("<!--[-1-->");
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<span style="color: var(--text-darker);">-</span>`);
                  }
                  $$renderer3.push(`<!--]--></td><td>`);
                  if (shard.size != null) {
                    $$renderer3.push("<!--[0-->");
                    $$renderer3.push(`${escape_html(formatBytes(shard.size))} `);
                    if (totalSize > 0) {
                      $$renderer3.push("<!--[0-->");
                      $$renderer3.push(`<span class="text-xs" style="color: var(--text-darker);">(${escape_html(pct(shard.size, totalSize))}%)</span>`);
                    } else {
                      $$renderer3.push("<!--[-1-->");
                    }
                    $$renderer3.push(`<!--]-->`);
                  } else {
                    $$renderer3.push("<!--[-1-->");
                    $$renderer3.push(`<span style="color: var(--text-darker);">-</span>`);
                  }
                  $$renderer3.push(`<!--]--></td></tr>`);
                }
                $$renderer3.push(`<!--]--></tbody></table></div>`);
              },
              $$slots: { default: true }
            });
            $$renderer2.push(`<!---->`);
          }
          $$renderer2.push(`<!--]-->`);
        }
        $$renderer2.push(`<!--]-->`);
      }
    );
    $$renderer2.push(`<!--]-->`);
  });
}
export {
  _page as default
};
